import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "../../../Assets/Css/AddUpdateInvoice.scss";
import "react-toastify/dist/ReactToastify.css";
import { customStyle } from "../../../Components/Style";
import "../../../Assets/Css/AddUpdateShareHolder.scss";
import Select from "react-select";
import { useLocation, useNavigate } from 'react-router-dom'
import {
    getShareholders,
} from "../../../Services/Shareholders/action";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import {
    getPurchaseInvoices,
    addPurchaseInvoice,
    updatePurchaseInvoice,
} from "../../../Services/Invoices/action";

const LeaveQuota = (props) => {

    const location = useLocation();
    const navigate = useNavigate();
    const [showLeaveQuota, setShowLeaveQuota] = useState(location?.pathname?.includes("edit"));
    const [isLoading, setIsLoading] = useState(false);
    const [finalData, setFinalData] = useState({
        seller_name: "",
        item_name: "",
        invoice_total: "",
        gst_amount: "",
        shareholder: "",
        purchase_date: null,
        url: ""
    });
    const [selectFilters, setSelectedFilters] = useState({
        date: "",
        status: [],
        leaveType: [],

    });
    let leaveTypeOptions = [
        { value: "Casual", label: "Casual" },
        { value: "Unpaid", label: "Unpaid" },
        { value: "Earned", label: "Earned" }
    ]

    const [isUpdate, setIsUpdate] = useState(false);
    const [purchaseInvoiceData, setPurchaseInvoiceData] = useState([]);
    const [shareholders, setShareholders] = useState([]);
    const [deletedItem, setDeletedItem] = useState({
        shareholders: [],
    })
    let [optionTypeShareHolders, setOptionTypeShareHolders] = useState([]);
    const [fileLinks, setFileLinks] = useState([]);
    const purchaseInvoiceId = location?.state?.data?.checkbox?.value;
    const purchaseInvdata = location?.state?.data;
    useEffect(() => {
        props.getPurchaseInvoices();
        props.getShareholders();
    }, []);

    useEffect(() => {
        const storedFiles = JSON.parse(localStorage.getItem('fileLinks')) || [];
        setFileLinks(storedFiles);
    }, []);

    useEffect(() => {
        localStorage.setItem('fileLinks', JSON.stringify(fileLinks));
    }, [fileLinks]);

    useEffect(() => {
        fetchAllData()
    }, []);

    useEffect(() => {
        setPurchaseInvoiceData(props?.purchaseInvoice);
    }, [props?.purchaseInvoice]);

    const fetchAllData = async () => {
        try {
            await props.getPurchaseInvoices(location.search);
            await props.getShareholders(location.search);
            if (purchaseInvoiceId) {
                setIsUpdate(true);
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const getShareHolderOption = () => {
        return props?.shareHolderDetails?.shareholders?.rows?.map((sh) => {
            return {
                value: sh,
                label: (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            width: "100%",
                            margin: 0,
                            padding: 0,
                        }}
                    >
                        <div style={{
                            display: "flex",
                            flexWrap: "wrap"
                        }}>
                            <span style={{ marginRight: "10px" }}>{sh.name}</span>
                        </div>
                        <div>
                        </div>
                    </div>
                ),
            };
        })
    }


    useEffect(() => {
        const options = getShareHolderOption();
        if (isUpdate) {
            (async () => {
                const shIdMap = props?.purchaseInvoice?.filter((f) => f.id === purchaseInvoiceId).flatMap((sh) => sh?.purchaseinvShareholderMap?.map((item) => item.shareholder_id)).join(', ')
                let filteredOptions = await options?.filter(item => shIdMap.includes(item?.value?.id));

                filteredOptions = filteredOptions?.map((item) => {
                    return {
                        ...item,
                        value: item.value,
                    };
                });
                setShareholders(filteredOptions);
                setOptionTypeShareHolders(options?.filter(item => !shIdMap.includes(item?.value?.id)));
            })()
        }
        else {
            setOptionTypeShareHolders(options)
        }
    }, [props?.shareHolderDetails?.shareholders?.rows, isUpdate]);


    useEffect(() => {

        if (isUpdate) {
            const existingUrls = props?.purchaseInvoice?.filter((item) => item.id === purchaseInvoiceId)?.flatMap((item) => item?.purchaseinvoiceMap?.map((url) => url.url));
            const fileLinksArray = existingUrls.map((url) => ({
                name: fileLinks.filter((item) => item.link === url).flatMap((item) => item.name),
                link: url
            }));
            setFileLinks(fileLinksArray);
            setFinalData({
                seller_name: purchaseInvdata?.Seller?.value,
                item_name: purchaseInvdata?.['Item-Name']?.value,
                invoice_total: purchaseInvdata?.['Invoice-Total']?.value.split('₹')[1],
                gst_amount: purchaseInvdata?.Gst?.value.split('₹')[1],
                shareholder: purchaseInvdata?.['Share Holders']?.value,
                purchase_date: purchaseInvdata?.Date ? moment(purchaseInvdata?.Date?.value).toDate() : null,
                url: fileLinks?.map((link) => link?.link)
            });
            values.seller_name = purchaseInvdata?.Seller?.value;
            values.item_name = purchaseInvdata?.['Item-Name']?.value;
            values.invoice_total = purchaseInvdata?.['Invoice-Total']?.value.split('₹')[1];
            values.gst_amount = purchaseInvdata?.Gst?.value.split('₹')[1];
            values.shareholder = purchaseInvdata?.['Share Holders']?.value;
            values.purchase_date = purchaseInvdata?.Date ? moment(purchaseInvdata?.Date?.value).toDate() : null;
            values.url = fileLinks?.map((link) => link?.link)
        }
    }, [isUpdate]);


    let initalVal = {
        seller_name: "",
        item_name: "",
        invoice_total: "",
        gst_amount: "",
        shareholder: "",
        purchase_date: null,
        url: ""
    };

    // SUBMIT
    const handleOnSubmit = async () => {
        setShowLeaveQuota(false)
        navigate('/employees/view/leave')
    }

    let { values, errors, touched, handleChange, handleSubmit } = useFormik({
        initialValues: initalVal,
        // validationSchema: isUpdate === false ? addPurchaseInvoiceValidation : '',
        onSubmit: handleOnSubmit
    });

    useEffect(() => {
        setFinalData({ ...values });
    }, [values]);

    const handleDeleteShareHolder = (valueToDelete) => {

        if (isUpdate) {
            let isDataPresent = props?.shareHolderDetails?.shareholders?.rows?.find(item => item.id == valueToDelete.value.id);
            if (isDataPresent) {
                const shareholdersId = props?.shareHolderDetails?.shareholders?.rows?.map((i) => i.id);
                // let deletes = valueToDelete.value.filter(item => shareholdersId.includes(item.id));
                let deleteField = { id: valueToDelete.value.id };
                setDeletedItem({
                    ...deletedItem,
                    shareholder: [...deletedItem["shareholders"], deleteField],
                });
            }
        }
        const filteredValues = shareholders?.filter((val) => val.value.id !== valueToDelete.value.id);
        setShareholders(filteredValues);
        const aleredyPresentShareHolder = optionTypeShareHolders.some(item => item.value.id === valueToDelete.value.id);
        if (aleredyPresentShareHolder === false) {
            optionTypeShareHolders = optionTypeShareHolders || [];
            valueToDelete.value.share_percentage = "";
            const data = [...optionTypeShareHolders, valueToDelete];
            let sortedData = data.sort((a, b) => a.value.id - b.value.id);
            setOptionTypeShareHolders(sortedData);
        }
    };

    const handleEdit = () => {
        navigate('/employees/view/leave/leaveQuota/edit')
        setShowLeaveQuota(true);
    }

    return (
        <div className="addUpdateShareholder-main">
            <div className="page-title">
                <h4>Leave Quota</h4>
                {showLeaveQuota ?
                    (
                        <div className="edit-btn">
                            <button
                                type="submit"
                                className="custom-btn"
                                onClick={() => navigate("/employees/view/leave")}
                            >
                                {/* {props.loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    className="custom-spinner"
                    role="status"
                    aria-hidden="true"
                  />
                ) : ( */}
                                Cancel
                                {/* )} */}
                            </button>

                            <button
                                type="submit"
                                className="custom-btn"
                                onClick={handleSubmit}
                            >
                                {/* {props.loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    className="custom-spinner"
                    role="status"
                    aria-hidden="true"
                  />
                ) : ( */}
                                Save
                                {/* )} */}
                            </button>
                        </div>
                    ) :
                    (
                        <div className="edit-btn">


                            <button
                                type="submit"
                                className="custom-btn"
                                onClick={() => navigate("/employees/view/leave")}
                            >
                                {/* {props.loading ? (
              <Spinner
                as="span"
                animation="border"
                className="custom-spinner"
                role="status"
                aria-hidden="true"
              />
            ) : ( */}
                                Cancel
                                {/* )} */}
                            </button>
                        </div>
                    )
                }
            </div>

            {/* <div className="page-title">
                <h4>Leave Quota</h4>
                {showLeaveQuota &&
                    (<div className="edit-btn">
                        <button className="custom-btn" type="submit" onClick={handleSubmit}>
                            {props.loading ? <Spinner as="span" animation="border" className="custom-spinner" role="status" aria-hidden="true" /> : 'Save'}
                        </button>
                    </div>)}
            </div> */}
            <div className="content-part">
                <div className="row">

                    {!showLeaveQuota ?
                        (<div className="col-lg-12">
                            <div className="leave-card">
                                <div className="custom-row">
                                    <div className="input-group">

                                        {/* <h5>Leaves Quota</h5> */}
                                        {/* <div style={{ display: "flex", gap: "5px", cursor: "pointer" }} onClick={handleEdit}>
                                                <FaCog color="blue" />
                                                <h6 style={{ color: "blue" }}>Manage</h6>
                                            </div> */}
                                    </div>

                                    <div className="leave-quota-card">
                                        <div className="row">
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">Leave Type</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">No. of Leaves</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">Monthly Limit</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">Total Leaves Taken</h6>
                                                </div>
                                            </div>
                                            <div style={{
                                                border: "2px solid #e9e7e7",
                                                borderRadius: "5px",
                                                marginTop: "10px"
                                            }}></div>
                                            <div className="col-lg-3 col-md-6">
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <div className="status-circle casual-leave" style={{ marginRight: "10px" }}>
                                                    </div>
                                                    <h6 className="label">Casual</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">21.5</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">30</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">13.5</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="leave-quota-card">
                                        <div className="row">
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">Leave Type</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">No. of Leaves</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">Monthly Limit</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">Total Leaves Taken</h6>
                                                </div>
                                            </div>
                                            <div style={{
                                                border: "2px solid #e9e7e7",
                                                borderRadius: "5px",
                                                marginTop: "10px"
                                            }}></div>
                                            <div className="col-lg-3 col-md-6">
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <div className="status-circle earned-leave" style={{ marginRight: "10px" }}>
                                                    </div>
                                                    <h6 className="label">Earned</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">21.5</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">30</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">13.5</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="leave-quota-card">
                                        <div className="row">
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">Leave Type</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">No. of Leaves</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">Monthly Limit</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">Total Leaves Taken</h6>
                                                </div>
                                            </div>
                                            <div style={{
                                                border: "2px solid #e9e7e7",
                                                borderRadius: "5px",
                                                marginTop: "10px"
                                            }}></div>
                                            <div className="col-lg-3 col-md-6">
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <div className="status-circle casual-leave" style={{ marginRight: "10px" }}>
                                                    </div>
                                                    <h6 className="label">Unpaid Leave</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">21.5</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">30</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-group">
                                                    <h6 className="label">13.5</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>) :
                        (<div className="col-lg-12">
                            <div className="leave-card">
                                <div className="custom-row">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-6">
                                            <div className="input-group">
                                                <div className="label">Leave Type</div>
                                                <Select
                                                    value={selectFilters.status}
                                                    onChange={(data) =>
                                                        setSelectedFilters({ ...selectFilters, status: data })
                                                    }
                                                    options={leaveTypeOptions}
                                                    placeholder={"--"}
                                                    styles={customStyle}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6">
                                            <div className="input-group">
                                                <h6 className="label">No. of leaves</h6>
                                                <input
                                                    disabled={isLoading}
                                                    type="number"
                                                    value={values.seller_name}
                                                    name="seller_name"
                                                    onChange={handleChange}
                                                    className="input-css"
                                                />
                                                {errors.seller_name && touched.seller_name ? (
                                                    <p className="error-text">{errors.seller_name}</p>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6">
                                            <div className="input-group">
                                                <h6 className="label">Monthly Limit</h6>
                                                <input
                                                    disabled={isLoading}
                                                    type="number"
                                                    value={values.seller_name}
                                                    name="seller_name"
                                                    onChange={handleChange}
                                                    className="input-css"
                                                />
                                                {errors.seller_name && touched.seller_name ? (
                                                    <p className="error-text">{errors.seller_name}</p>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6">
                                            <div className="input-group">
                                                <h6 className="label">Total leaves taken</h6>
                                                <input
                                                    disabled={isLoading}
                                                    type="number"
                                                    value={values.seller_name}
                                                    name="seller_name"
                                                    onChange={handleChange}
                                                    className="input-css"
                                                />
                                                {errors.seller_name && touched.seller_name ? (
                                                    <p className="error-text">{errors.seller_name}</p>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                </div>
            </div>

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.shareholdersReducer.loading,
        shareHolderDetails: state.shareholdersReducer,
        success: state.shareholdersReducer.success,
        purchaseInvoice: state.invoicesReducer.purchaseInvoice,
    }
}

const mapDispatchToProps = {
    getShareholders: getShareholders,
    addPurchaseInvoice: addPurchaseInvoice,
    updatePurchaseInvoice: updatePurchaseInvoice,
    getPurchaseInvoices: getPurchaseInvoices,
}
export default connect(mapStateToProps, mapDispatchToProps)(LeaveQuota);
